<template>
  <auth-layout>
    <div class="c-auth-card c-login-card">
      <div class="c-auth-card__top">
        <form @submit="login" method="post">
          <div class="c-auth-card__head">
            <img src="~@/assets/img/logo.svg" class="logo" alt="Sber logo">
          </div>
          <div class="c-auth-card__body c-login-card__body">
            <form-control
              :placeholder="payload.username.placeholder"
              :error="payload.username.error"
              :short="payload.username.short"
              :type="payload.username.type"
              v-model="payload.username.value"
              required
              autofocus
            />
            <form-control
              :placeholder="payload.password.placeholder"
              :error="payload.password.error"
              :short="payload.password.short"
              :type="payload.password.type"
              :iconType="payload.password.iconType"
              :iconClick="togglePassword"
              v-model="payload.password.value"
              required
            />
          </div>
          <div class="c-auth-card__controlls c-login-card__controlls">
            <button type="submit" class="button button__bold">Войти</button>
            <router-link to="/change_password" class="link link__ui">Забыли пароль?</router-link>
          </div>
        </form>
      </div>
      <div class="c-auth-card__bottom c-login-card__bottom">
        <p class="text">Нет учётной записи? <router-link to="/signup" class="link link__bold">Зарегистрироваться</router-link></p>
      </div>
    </div>
  </auth-layout>
</template>
<script>
import AuthLayout from "@/layouts/AuthLayout";
import FormControl from "@/components/forms/FormControl";

export default {
  data() {
    return {
      payload: {
        username: {
          value: "",
          short: "",
          error: "",
          placeholder: "Мобильный телефон или логин",
          type: "text"
        },
        password: {
          value: "",
          short: "",
          error: "",
          placeholder: "Пароль",
          type: "password",
          iconType: "password"
        }
      }
    };
  },
  components: {
    AuthLayout,
    FormControl
  },
  methods: {
    togglePassword(data) {
      if (data.click) {
        if (this.payload.password.type === "password") {
          this.payload.password.type = "text";
        } else {
          this.payload.password.type = "password";
        }
      }
    },
    login(e) {
      e.preventDefault();
      console.log(this.payload, "login");
    }
  }
};
</script>
